import { ActivityStep, NotificationRow } from "@cnx/common";
import { Box, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface ChangeRowCardProps {
  notificationRows: NotificationRow[];
}

const translate = (title: string, translationMap: Map<string, string>) => {
  const translationKeys = Array.from(translationMap.keys());

  translationKeys?.forEach(key => {
    title = title.replace(
      new RegExp(`<${key}>`, "g"),
      translationMap.get(key) ?? ""
    );
  });

  title = title.replace(/<|>/g, "");

  return title;
};

const ChangeRowCard: React.FC<ChangeRowCardProps> = ({ notificationRows }) => {
  if (!notificationRows.length) {
    return <></>;
  }

  const { t } = useTranslation("tripActivity");

  const translationMap = new Map<string, string>();

  translationMap.set(ActivityStep.COUPLING, t("activityCoupling"));
  translationMap.set(ActivityStep.LOADING, t("activityLoading"));
  translationMap.set(ActivityStep.UNLOADING, t("activityUnloading"));
  translationMap.set(ActivityStep.DECOUPLING, t("activityDecoupling"));
  translationMap.set(ActivityStep.TO_SHIP, t("activityToShip"));
  translationMap.set(ActivityStep.FROM_SHIP, t("activityFromShip"));
  translationMap.set(ActivityStep.TO_TRAIN, t("activityToTrain"));
  translationMap.set(ActivityStep.FROM_TRAIN, t("activityFromTrain"));
  translationMap.set(ActivityStep.DIVIDER, t("activityDivider"));
  translationMap.set(ActivityStep.CUSTOMS, t("activityCustoms"));
  translationMap.set(ActivityStep.REST, t("activityRest"));
  translationMap.set(ActivityStep.STOPPED, t("activityStop"));
  translationMap.set(ActivityStep.MAINTENANCE, t("activityMaintenance"));
  translationMap.set(ActivityStep.INFO, t("activityInfo"));
  translationMap.set(ActivityStep.DRIVER_CHANGE, t("activityDriverChange"));

  if (notificationRows.length === 1) {
    return (
      <>
        <Text fz={"sm"} lh={1}>
          {translate(notificationRows[0].title, translationMap)}
        </Text>
        {notificationRows[0].description && (
          <Text lh={1} fz={10} c={"gray.7"}>
            {notificationRows[0].description}
          </Text>
        )}
      </>
    );
  }

  return (
    <ul className="list-inside mt-[10px] list-disc">
      {notificationRows.map(({ id, title, description }) => {
        return (
          <li key={id} className={"flex items-center custom-list-item"}>
            <Box>
              <Text fz={"sm"} lh={1}>
                {translate(title, translationMap)}
              </Text>
              {description && (
                <Text lh={1} fz={10} c={"gray.7"}>
                  {description}
                </Text>
              )}
            </Box>
          </li>
        );
      })}
    </ul>
  );
};

export default ChangeRowCard;
